import { Autocomplete, TextField } from "@mui/material";
import { useEffect } from "react";
import { useMotivoAfastamentoStore } from "../../stores/rh/motivoAfastamento";


interface Props {
  value: number | null
  onChange: (value: number | null) => void
  required?: boolean
  erro?: boolean
  messageErro?: string
  disabled?: boolean
  onOpen?: () => void
}

function MotivoAfastamentoSelect({ value, onChange, required = false, erro = false, messageErro = "", disabled = false, onOpen }: Props) {
  const { motivoAfastamentoResume, setMotivoAfastamentoResume, loadingMotivoAfastamentoResume, erroMotivoAfastamentoResume, setErroMotivoAfastamentoResume } = useMotivoAfastamentoStore()

  useEffect(() => {
    if (motivoAfastamentoResume.length === 0) {
      setMotivoAfastamentoResume()
    }
  }, [])

  return (
    <Autocomplete
      id="afastamento-select"
      disabled={disabled}
      options={motivoAfastamentoResume}
      onOpen={async () => {
        if (onOpen) {
          onOpen()
        }
        if (motivoAfastamentoResume.length === 0) {
          await setMotivoAfastamentoResume()
        }
        else {
          setErroMotivoAfastamentoResume(false)
        }
      }
      }
      value={value != null ? motivoAfastamentoResume.find((option) => option.idMotivoAfastamento == value) : null}
      getOptionLabel={(option) => option.descricaoMotivo ?? "-"}
      onChange={(event, newValue) => {
        onChange(newValue?.idMotivoAfastamento ?? null)
      }}
      isOptionEqualToValue={(option, selectedOption) => option.idMotivoAfastamento === selectedOption.idMotivoAfastamento}
      getOptionKey={(x) => x.idMotivoAfastamento}
      filterSelectedOptions
      loading={loadingMotivoAfastamentoResume}
      renderInput={(params) => (
        <TextField
          {...params}
          required={required}
          disabled={disabled}
          size="small"
          label="Motivo do afastamento"
          error={erroMotivoAfastamentoResume || erro}
          helperText={erroMotivoAfastamentoResume == true ? "Houve algum erro ao buscar os motivos de afastamento" : (erro == true ? messageErro : "")}
        />
      )}
    />
  );
}

export default MotivoAfastamentoSelect;